<template>
    <v-group>
        <v-group v-for="angle in angles" :key="angle.id">
            <Angle
                   :pointCenter="angle.pointCenter"
                   :angleDirectionStart="angle.angleDirectionStart"
                   :angleSize="angle.angleSize"
                   :hidden="angle.angleIsHidden"
            ></Angle>
        </v-group>


        <v-group v-for="line in lines" :key="line.id">
            <LineWithRibs v-if="line.type === 'lineWithRibs'"
                          :id="line.id"
                          :type="line.type"
                          :fromPoint="line.fromPoint"
                          :toPoint="line.toPoint"
                          :lineLengthIsHidden="line.lineLengthIsHidden"
                          :ribLinePoints="line.ribLinePoints"
                          :lineColor="lineColor"
                          :lineColorHover="lineColorHover"
            ></LineWithRibs>
            <Line v-else-if="line.type === 'simpleLine'"
                  :id="line.id"
                  :type="line.type"
                  :fromPoint="line.fromPoint"
                  :toPoint="line.toPoint"
                  :lineLengthIsHidden="line.lineLengthIsHidden"
                  :lineColor="lineColor"
                  :lineColorHover="lineColorHover"
            ></Line>
        </v-group>

        <v-group v-for="line in lines" :key="line.id">
            <LineFold v-if="line.type === 'fold'"
                      :id="line.id"
                      :fromPoint="line.fromPoint"
                      :toPoint="line.toPoint"
                      :lineColor="lineColor"
                      :lineColorHover="lineColorHover"
            ></LineFold>
        </v-group>

        <v-group v-for="(hem, index) in hems" :key="index">
            <Hem v-if="hem"
                 :id="hem.id"
                 :type="hem.type"
                 :lineColor="lineColor"
                 :lineColorHover="lineColorHover"
                 :size="hem.size"
                 :flip="hem.flip"
                 :isHover="hem.isHover"
            ></Hem>
        </v-group>

        <v-group v-if="displayPointers">
            <v-group v-for="point in lineEndPointers" :key="point.id">
                <Pointer v-if="!disableEndPointer(point)"
                         :id="point.id"
                         :x="point.x"
                         :y="point.y"
                         :lineColor="lineColor"
                         :lineColorHover="lineColorHover"
                         :fillColor="'#79afee'"
                ></Pointer>
            </v-group>
        </v-group>
    </v-group>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import Line from './Line';
    import Pointer from './Pointer';
    import Angle from "./Angle";
    import Hem from "./Hem";
    import LineFold from "./LineFold";
    import LineWithRibs from "./lineWithRibs/LineWithRibs";

    export default {
        name: "Trim",

        components: {
            LineWithRibs,
            LineFold,
            Hem,
            Angle,
            Line,
            Pointer,
        },

        data() {
            return {
                lineColor: '#333',
                lineColorHover: '#42648f',
            }
        },

        computed: {
            ...mapState('editor', [
                'points',
                'userAction',
                'USER_ACTIONS',
            ]),

            ...mapGetters('editor', [
                'getPointIndexById',
                'endPointers',
                'hems',
                'hemPreviousPoint',
                'trimEditDisabled',
            ]),

            ...mapGetters('angles', [
                'getAngles',
            ]),

            ...mapGetters('line', [
                'getLines',
            ]),

            angles() {
                return this.getAngles(this.points);
            },

            lines() {
                return this.getLines(this.points);
            },

            lineEndPointers() {
                return this.endPointers.filter(pointer => {
                    return !pointer.hem;
                });
            },

            displayPointers() {
                return !this.trimEditDisabled && this.userAction !== this.USER_ACTIONS.SELECT;
            },
        },

        methods: {
            disableEndPointer(point) {
                let prevPointIndex = this.getPointIndexById(point['id']);

                // check only the previous point at the end of the trim; check at the start no make sense
                let prevPoint = this.points[prevPointIndex - 1];

                let hasFold = point['type'] === 'fold' || prevPoint?.type === 'fold';

                // disable if the user action is the SET_FOLD but the Pointer is already has a Fold
                let disable = hasFold && this.userAction === this.USER_ACTIONS.SET_FOLD;

                return disable;
            },

        },

    }
</script>

<style scoped>

</style>